<template>
  <vxe-modal
    ref="xModal"
    v-model="formVisible"
    :title="'权限' + modalType"
    width="80%"
    height="80%"
    show-zoom
    @zoom="zoomWindow"
    @show="showModal"
    :before-hide-method="beforeHideModal"
    @close="closeModal"
  >
    <el-form
      :model="form"
      ref="FormRef"
      :validate-on-rule-change="false"
      :rules="rules"
      size="small"
    >
      <!-- 第一行 -->
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="年份" prop="nian">
            <!-- <el-input
              v-model="form.nian"
              autocomplete="off"
              :placeholder="placeholderConfig.select"
            ></el-input> -->
            <el-select
              clearable
              v-model="form.nian"
              :disabled="!parentData.Authority.edit"
              :placeholder="placeholderConfig.select"
            >
              <el-option
                v-for="(i, index) of ComBoxItems.year"
                :key="index"
                :label="i.name"
                :value="i.value"
              ></el-option>
            </el-select>
            <template slot="error" slot-scope="slot">
              <errorTooltip :content="slot.error"></errorTooltip>
            </template>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!-- <el-divider content-position="left">菜单列表</el-divider> -->
    <YKDivider content-position="left">明细列表</YKDivider>
    <!-- 菜单权限明细table -->
    <vxe-grid
      ref="xTable"
      size="mini"
      :column-config="{ minWidth: '80px' }"
      border
      keep-source
      :height="tableHeight"
      :cell-class-name="cellClassName"
      resizable
      :edit-rules="validRules"
      show-overflow
      :data="form.detailList"
      highlight-hover-row
      highlight-current-row
      :mouse-config="{ area: true, extension: true }"
      :edit-config="{
        trigger: 'dblclick',
        mode: 'cell',
        activeMethod: activeMethod
      }"
      :keyboard-config="{
        isArrow: true,
        isEnter: true,
        isTab: true,
        isClip: true,
        enterToTab: true,
        isEdit: true,
        editMethod: editMethod
      }"
      :menu-config="{
        body: { options: bodyMenus },
        visibleMethod: visibleMethod
      }"
      @cell-menu="cellContextMenuEvent"
      :columns="tableColumn"
      @menu-click="contextMenuClickEvent"
      :toolbar="tableToolbar"
      @toolbar-button-click="toolbarButtonClickEvent"
    >
    </vxe-grid>
    <!-- 间隔槽（内含保存按钮） -->
    <div class="gap-dv">
      <button @click="save">保存</button>
    </div>
    <!-- 日期选择框 -->
    <HolidayDateInput ref="HolidayDateInput" @sureHandler="sureHandler" />
  </vxe-modal>
</template>
<script>
import HolidayDateInput from './HolidayDateInput.vue'
export default {
  components: {
    HolidayDateInput
  },
  props: {
    modalType: {
      type: String,
      default: '新增'
    },
    parentData: {
      type: Object,
      default: () => {
        return {
          Authority: {
            see: false,
            edit: false
          }
        }
      }
    },
    updateForm: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      id: 0,
      formVisible: false,
      form: {
        id: 0,
        nian: '',
        detailList: []
      },
      rules: {

      },
      // 明细验证规则
      validRules: {},
      // 明细验证错误
      errIndex: [],
      bodyMenus: [
        [

        ]
      ],
      // 列头
      tableColumn: [],
      // 高度百分百比
      zoomHeightRatio: 0.8,
      // tabel工具栏
      tableToolbar: {},
      // 是否修改过
      IfExistModify: false,
      // 下拉框
      ComBoxItems: {
        year: [
          {
            name: '2021',
            value: '2021'
          },
          {
            name: '2022',
            value: '2022'
          },
          {
            name: '2023',
            value: '2023'
          },
          {
            name: '2024',
            value: '2024'
          },
          {
            name: '2025',
            value: '2025'
          },
          {
            name: '2026',
            value: '2026'
          },
          {
            name: '2027',
            value: '2027'
          },
          {
            name: '2028',
            value: '2028'
          },
          {
            name: '2029',
            value: '2029'
          },
          {
            name: '2030',
            value: '2030'
          },
          {
            name: '2030',
            value: '2030'
          },
        ]
      },
      // 右键缓存
      areas: {},
      colProperty: '',
      cacheRowIndex: -1,
      cacheRow: {},
      // 明细新增数据
      insertRecords: [],
      // 明细更新数据
      updateRecords: [],
      // 明细删除数据
      removeRecords: [],
      IfDataBindComplete: false
    }
  },
  created () {
    this.InitColumn()
  },
  methods: {
    // 返回日期
    sureHandler (form) {
      const day = Number(form.day)
      if (day > 1) {
        for (let i = 0; i < day; i++) {
          if (i === 0) {
            this.areas.forEach(area => {
              for (let row of area.rows) {
                for (let col of area.cols) {
                  if (col.property === this.colProperty) {
                    row[this.colProperty] = form.date
                  }
                }
              }
            })
          } else {
            let row = {
              // ...this.cacheRow,
              holidayName: this.cacheRow['holidayName'] ? this.cacheRow['holidayName'] : '',
              holidayDate: this.ykDateFormat('yyyy-MM-dd', this.$utils.getWhatDay(form.date, day - i)),
              type: this.cacheRow['type'] ? this.cacheRow['type'] : '',
              memo: this.cacheRow['memo'] ? this.cacheRow['memo'] : '',
            }
            // this.form.detailList.splice(this.cacheRowIndex + 1, 0, row)
            this.addInsertRecords(row, 'fill', this.cacheRowIndex)
          }
        }
      } else {
        this.areas.forEach(area => {
          for (let row of area.rows) {
            for (let col of area.cols) {
              if (col.property === this.colProperty) {
                row[this.colProperty] = form.date
              }
            }
          }
        })
      }
      // const table = this.$refs.xTable.getTableData().fullData

      // this.$utils.getWhatDay(date, day) 返回日期的后几天


    },
    // 初始化列头
    InitColumn () {
      let that = this
      that.tableColumn = [
        {
          type: 'seq',
          width: '50',
          className: 'seqErrorVaildClass',
          slots: {
            default: ({ row }) => {
              if (row.ifRepeat) {
                return [<el-tooltip class="tooltipItem"
                  effect="light" content={row.repeatText} placement="right" >
                  <div style="width: 100%; height: 100%">
                    <span>{this.$refs.xTable.getVTRowIndex(row) + 1}</span>
                  </div>
                </el-tooltip>]
              } else {
                return [<span>{this.$refs.xTable.getVTRowIndex(row) + 1}</span>]
              }
            }
          }
        },
        { field: 'delete', title: '删除', visible: this.parentData.Authority.edit, width: '50', align: 'center', slots: { default: ({ row }) => { return [<i id="vxeDelete" class="el-icon-delete-solid" onClick={() => { this.handleRemoveRowForTable(row, this.$refs.xTable, this.$data) }} ></i>] } } },
        {
          title: '节假日',
          field: 'holidayName',
          editRender: {
            name: '$input', attrs: { disabled: true }
          }
        },
        {
          title: '日期', field: 'holidayDate',
          formatter: ['formatDate', 'yyyy-MM-dd'],
          editRender: {
            name: '$input', attrs: { disabled: true }
          }
        },
        {
          title: '类型', field: 'type',
          editRender: {
            name: '$input', attrs: { disabled: true }
          }
        },
        {
          title: '备注', field: 'memo',
          editRender: {
            name: 'input'
          }
        }
      ]
    },
    // 获取权限
    InitRight () {
      // tabel工具栏
      this.tableToolbar = {
        buttons: [
          {
            code: 'insertOne',
            name: '新增1行',
            disabled: !this.parentData.Authority.edit
          },
          {
            code: 'insertTen',
            name: '新增10行',
            disabled: !this.parentData.Authority.edit
          }
        ]
      }
    },
    // 按下右键缓存选中列
    cellContextMenuEvent ({ row, column, rowIndex }) {
      this.areas = this.$refs.xTable.getCellAreas()
      this.colProperty = column.property
      if (this.parentData.Authority.edit && column.property === 'holidayDate') {
        this.cacheRowIndex = rowIndex
        this.cacheRow = row
        this.$refs.HolidayDateInput.formVisible = true
      }
    },
    // table 点击删除列
    handleRemoveRowForTable (row, table, data) {
      this.$confirm('确定要删除本行吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          table.remove(row)
          this.addRemoveRecords(row)
          if (data) {
            data.IfExistModify = true
          }
        })
        .catch(() => { })
    },
    // 删除列后处理数据
    addRemoveRecords (row) {
      if (row.id) {
        // 1.有行id的，才需要将删除的行数据放进 removeRecords 中
        // 2.首次新增的数据无id，该类数据不放进 removeRecords
        this.removeRecords.push(row)
      }
      // 2.将被删除的行数据，从 form.detailList | insertRecords | updateRecords 中删掉
      for (let i = 0; i < this.form.detailList.length; i++) {
        // 数据首次新增时，还没有id，需要用 _XID 来匹配行
        if (this.form.detailList[i]._XID === row._XID) {
          this.form.detailList.splice(i, 1)
          break
        }
      }
      for (let j = 0; j < this.insertRecords.length; j++) {
        if (this.insertRecords[j]._XID === row._XID) {
          this.insertRecords.splice(j, 1)
          break
        }
      }
      for (let z = 0; z < this.updateRecords.length; z++) {
        if (this.updateRecords[z]._XID === row._XID) {
          this.updateRecords.splice(z, 1)
          break
        }
      }
    },
    // 新增明细数据
    addInsertRecords (row, type = 'add', cacheRowIndex) {
      if (type === 'add') {
        // 1.直接新增到 xTable 的 data 中
        this.form.detailList.push(row)
      } else {
        this.form.detailList.splice(cacheRowIndex + 1, 0, row)
      }
      // 2.记录到 insertRecords 中用于更新
      this.insertRecords.push(row)
    },
    // 更新明细数据（导入 | 触发编辑）
    addUpdateRecords (row) {
      // 只有该行有 id，才能放进 updateRecords
      if (row.id > 0) {
        let option = this.updateRecords.filter(item => {
          return item.id === row.id
        })
        if (option.length === 0) {
          this.updateRecords.push(row)
        }
      }
    },
    // table工具栏方法
    toolbarButtonClickEvent ({ code }) {
      switch (code) {
        case 'insertOne':
          this.insertEvent()
          break
        case 'insertTen':
          this.insertTenEvent()
          break
      }
    },
    // 新增一行
    insertEvent () {
      let record = {
        holidayName: '',
        holidayDate: '',
        type: '',
        memo: ''
      }
      this.addInsertRecords(record)
      // this.$refs.xTable.insertAt(record, -1)
      this.IfExistModify = true
    },
    // 新增10行
    insertTenEvent () {
      let record = {
        holidayName: '',
        holidayDate: '',
        type: '',
        memo: ''
      }
      for (var i = 0; i < 10; i++) {
        this.addInsertRecords(record)
        // this.$refs.xTable.insertAt(record, -1)
      }
      this.IfExistModify = true
    },
    async showModal () {
      this.IfDataBindComplete = false
      this.setFormVaild()
      this.resetXTableRecords()
      this.InitRight()
      await this.BindComBox()
      switch (this.modalType) {
        case '新增':
          this.id = 0
          this.form = {
            id: 0,
            nian: new Date().getFullYear(),
            detailList: []
          }
          break
        case '修改':
          this.id = this.updateForm.id
          await this.getBoth(this.id)
          break
      }
      this.$nextTick(() => {
        this.$refs.FormRef.clearValidate()
        this.IfDataBindComplete = true
        this.IfExistModify = false
      })
    },
    // 在保存单据后，清空新增、删除、修改的过程记录
    resetXTableRecords () {
      this.insertRecords = []
      this.updateRecords = []
      this.removeRecords = []
    },
    // 绑定下拉框
    async BindComBox () {
      this.bodyMenus = [[]]
      const { data: selectRes } = await this.$http.get('/Common/YKHoliday/select-item')
      if (selectRes.isSuccess) {
        for (let item of selectRes.data) {
          switch (item.code) {
            case 'holidayType':
            case 'holidayName':
              this.bodyMenus[0].push(item)
              break
          }
        }
      }
    },
    // 获取明细数据
    async getBoth (id) {
      this.id = id
      const { data: res } = await this.$http.get('/Common/YKHoliday/both',
        {
          params: {
            id: id
          }
        }
      )
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.form = res.data
      this.$nextTick(() => {
        this.$refs.FormRef.clearValidate()
        this.IfExistModify = false
      })
    },
    async beforeHideModal () {
      if (!(await this.closeModal())) {
        return new Error()
      }
    },
    async closeModal () {
      let ifClose = false
      if (this.IfExistModify) {
        await this.$confirm('您已做出修改，是否关闭窗口？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            ifClose = true
          })
          .catch(() => {
          })
      } else {
        ifClose = true
      }
      return ifClose
    },
    // 最大化事件
    zoomWindow (e) {
      if (e.type === 'max') {
        this.zoomHeightRatio = 1
      } else {
        this.zoomHeightRatio = 0.8
      }
    },
    // 初始化校验规则
    setFormVaild () {
      this.rules = {
        nian: [
          { required: true, message: '请选择年份', trigger: 'change' }
        ]
      }
      this.validRules = {
        holidayName: [
          { required: true, message: '请选择节假日名称', trigger: 'change' },
          {
            min: 0,
            max: 4,
            message: '节假日名称长度应在 0 到 4 个字符',
            trigger: 'change'
          }
        ],
        holidayDate: [
          { required: true, message: '请选择日期', trigger: 'change' }
        ],
        type: [
          { required: true, message: '请选择类型', trigger: 'change' },
          {
            min: 0,
            max: 2,
            message: '类型长度应在 0 到 2 个字符',
            trigger: 'change'
          }
        ],
        memo: [
          {
            min: 0,
            max: 64,
            message: '备注长度应在 0 到 64 个字符',
            trigger: 'change'
          }
        ]
      }
    },
    // 保存
    save () {
      if (!this.parentData.Authority.edit) {
        this.$message.error('您没有编辑权限')
        return
      }
      this.validEnter().then(async result => {
        if (result) {
          if (this.id && this.id > 0) {
            this.update()
          } else {
            this.add()
          }
        }
      })
    },
    // 新增
    async add () {
      let form = { ...this.form }
      // let insertRecords = this.$refs.xTable.getInsertRecords()
      form.detailList = this.insertRecords
      form = this.removeObjectNull(form)
      form.detailList = this.removeArrayNull(form.detailList)
      const { data: res } = await this.$http.post('/Common/YKHoliday/both', form)
      if (res.isSuccess) {
        this.id = res.data
        this.$message.success(this.messageConfig.save.success)
        this.IfExistModify = false
        this.parentData['list']('add', res.data)
        this.$emit('updateModalType', '修改')
        this.id = res.data
        this.resetXTableRecords()
        this.getBoth(res.data)
        this.$nextTick(() => {
          this.$refs.FormRef.clearValidate()
          this.IfExistModify = false
        })
      } else {
        this.$message.error(res.errorMessage)
      }
    },
    // 修改
    async update () {
      let form = { ...this.form }
      // let insertRecords = this.$refs.xTable.getInsertRecords()
      // let removeRecords = this.$refs.xTable.getRemoveRecords()
      // let updateRecords = this.$refs.xTable.getUpdateRecords()
      form.detailList = []
      for (let item of this.insertRecords) {
        form.detailList.push(item)
      }
      for (let item of this.removeRecords) {
        item.id = item.id > 0 ? 0 - item.id : item.id
        form.detailList.push(item)
      }
      for (let item of this.updateRecords) {
        form.detailList.push(item)
      }
      form = this.removeObjectNull(form)
      form.detailList = this.removeArrayNull(form.detailList)
      const { data: res } = await this.$http.put('/Common/YKHoliday/both', form)
      if (res.isSuccess) {
        this.$message.success(this.messageConfig.save.success)
        this.IfExistModify = false
        this.parentData['list']('update', this.form.id)
        this.resetXTableRecords()
        this.getBoth(this.id)
      } else {
        this.$message.error(res.errorMessage)
      }
    },
    // 验证
    async validEnter () {
      let flag = true
      await this.$refs.FormRef.validate().then(
        res => {
          flag = res
        },
        err => {
          flag = err
        }
      )
      this.errIndex = []
      const errMap = await this.$refs.xTable.fullValidate(true).catch(errMap => errMap)
      if (errMap) {
        Object.values(errMap).forEach(errList => {
          errList.forEach(params => {
            let { row, columnIndex, rules } = params
            rules.forEach(() => {
              this.errIndex.push({
                _XID: row._XID,
                columnIndex: columnIndex
              })
            })
          })
        })
        if (this.errIndex.length > 0) {
          flag = false
        }
      }
      // 重复行
      this.repeatForTable(this.errIndex, this.$refs.xTable, ['holidayName', 'holidayDate'])
      if (this.errIndex.length > 0) {
        flag = false
        this.$message.error('验证失败,请核对输入数据')
        return false
      }
      if (!flag) {
        this.$message.error('验证失败,请核对输入数据')
      }
      return flag
    },
    // 单元格设置样式,错误提示
    cellClassName ({ row, columnIndex }) {
      var a = this.errIndex.find(item => {
        return item._XID === row._XID && item.columnIndex === columnIndex
      })
      if (a) {
        return 'cell-valid'
      }
    },
    // cell激活控制
    activeMethod ({ column, row }) {
      if (!this.parentData.Authority.edit) {
        return false
      }
      if (column.editRender && column.editRender.attrs && column.editRender.attrs.disabled === true) {
        return false
      }
      // 一旦激活单元格，则将当前行视为更新过内容，放进 updateRecords 中
      // 按键激活和双击激活都会触发 activeMethod
      this.addUpdateRecords(row)
      return true
    },
    // cell编辑控制
    editMethod ({ row, column, $table }) {
      if (!this.parentData.Authority.edit) {
        return false
      }
      if (column.editRender && column.editRender.attrs && column.editRender.attrs.disabled === true) {
        return false
      }
      // 单击单元格输入不算是激活 所以两个地方都得加
      // this.addUpdateRecords(row)
      row[column.property] = null
      $table.setActiveCell(row, column.property)
      return true
    },
    // 快捷键
    visibleMethod ({ options, column }) {
      options.forEach(list => {
        list.forEach(item => {
          item.disabled = !this.parentData.Authority.edit
          if (!column) {
            item.visible = false
          } else if (item.code === 'holidayName' && column.property === 'holidayName') {
            item.visible = true
          } else if (item.code === 'holidayType' && column.property === 'type') {
            item.visible = true
          } else {
            item.visible = false
          }
        })
      })
      return true
    },
    async contextMenuClickEvent ({ menu }) {
      switch (menu.code) {
        case 'holidayName':
        case 'holidayType':
          this.areas.forEach(area => {
            for (let row of area.rows) {
              for (let col of area.cols) {
                if (col.property === this.colProperty) {
                  row[this.colProperty] = menu.name
                }
              }
            }
          })
          break
      }
    }
  },
  computed: {
    tableHeight () {
      const titleHeight = 42.5
      const formHeight = 66
      const divider = this.$store.state.ykDivider
      const buttonHeight = 40
      let height = (Number(this.$store.state.clientHeight) * this.zoomHeightRatio - 25 -
        titleHeight - formHeight - divider - buttonHeight)
      return height + 'px'
    }
  },
  watch: {
    form: {
      handler () {
        if (this.IfDataBindComplete) {
          this.IfExistModify = true
        }
      },
      deep: true
    }
  }
}
</script>
<style lang='less' scoped>
// 间隔槽总高度 = 高度 + margin
@gap-margin: 10px;
@gap-height: 30px;
@gap-padding-bottom: 10px;
.gap-dv {
  width: 100%;
  height: @gap-height;
  margin: @gap-margin 0 0 0;
  // padding-bottom: @gap-padding-bottom;
  // border-bottom: 1px solid #f2f3f5;
  .fl;

  > button {
    width: 180px;
    height: 30px;
    font-size: 14px;
    border-radius: 5px;
    background-color: @primary-color;
    color: @text-color;
    outline: none;
    border: none;
    transition: @normal-transition;
  }

  > button:hover {
    cursor: pointer;
    opacity: 0.7;
  }

  > button:active {
    opacity: 0.9;
  }
}
#vxeDelete {
  color: red;
}
</style>